/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [index.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 27.09.18 13:13
 */

import axios from 'axios';

import {authConfig, getLocalSiteConfiguration, isPreAuthorized, removeBearer,} from "./local-storage";
import {
    anonymousFetchChatCount,
    anonymousFetchChatEntries,
    anonymousFetchComments,
    anonymousFetchFollowees,
    anonymousFetchFollowers,
    anonymousFetchFriends,
    anonymousFetchFriendsPending,
    anonymousFetchLoginData,
    anonymousFetchPosts,
    anonymousFetchPostsPage,
    anonymousFetchUserData
} from "./anonymous";

import {environment as env} from './environment';
import {asyncHandleError, checkIsServerAlive, isServerAlive} from "./error-handling";

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const CREATE_USER_RESET = 'CREATE_USER_RESET';
export const UPDATE_USERDATA = 'UPDATE_USERDATA';
export const UPDATE_USERDATA_SECURITY = 'UPDATE_USERDATA_SECURITY';
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_POSTS_PAGE = 'FETCH_POSTS_PAGE';
export const FETCH_POST = 'fetch_post';
export const CREATE_POST = 'create_post';
export const UPDATE_POST = 'UPDATE_POST';
export const UPDATE_POST_RANKING = 'UPDATE_POST_RANKING';
export const DELETE_POST = 'DELETE_POST';
export const SHARE_POST = 'SHARE_POST';
export const HIDE_POST = 'HIDE_POST';
export const DELETE_POST_MEDIA = 'DELETE_POST_MEDIA';
export const REORDER_POST_MEDIA = 'REORDER_POST_MEDIA';
export const FETCH_COMMENTS = 'fetch_comments';
export const CREATE_COMMENT = 'create_comment';
export const CREATE_COMMENT_LIKE = 'create_comment_like';
export const REMOVE_COMMENT_LIKE = 'REMOVE_COMMENT_LIKE';
export const CREATE_LIKE = 'create_like';
export const REMOVE_LIKE = 'REMOVE_LIKE';
export const FETCH_CONTACTS = 'fetch_contacts';
export const FETCH_FRIENDS = 'fetch_friends';
export const FETCH_FRIENDS_PENDING = 'fetch_friends_pending';
export const ADD_FRIEND = 'add_friend';
export const DELETE_FRIEND = 'delete_friend';
export const BLOCK_FRIEND = 'block_friend';
export const UNBLOCK_FRIEND = 'unblock_friend';
export const IGNORE_FRIEND = 'ignore_friend';
export const ACCEPT_FRIEND = 'accept_friend';
export const CANCEL_FRIEND = 'cancel_friend';
export const FETCH_FOLLOWERS = 'fetch_followers';
export const FETCH_FOLLOWEES = 'fetch_followees';
export const ADD_FOLLOWEE = 'add_followee';
export const BLOCK_FOLLOWER = 'block_follower';
export const UNBLOCK_FOLLOWER = 'unblock_follower';
export const DELETE_FOLLOWEE = 'delete_followee';

export const FETCH_LOGINDATA = 'FETCH_LOGINDATA';
export const RESET_LOGINDATA = 'RESET_LOGINDATA';
export const UPDATE_LOGINDATA = 'UPDATE_LOGINDATA';
export const UPDATE_SURROGATEDATA = 'UPDATE_SURROGATEDATA';
export const LOCAL_UPDATE_LOGINDATA = 'LOCAL_UPDATE_LOGINDATA';
export const UPDATE_LOGINDATA_ACCOUNT = 'UPDATE_LOGINDATA_ACCOUNT';
export const UPDATE_LOGINDATA_ADDRESS = 'UPDATE_LOGINDATA_ADDRESS';

export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const FETCH_USERDATA = 'FETCH_USERDATA';

export const NOTIFY_PAGE_CHANGE = 'NOTIFY_PAGE_CHANGE'
export const NOTIFY_SPACE_CHANGE = 'NOTIFY_SPACE_CHANGE'
export const NOTIFY_GALLERY_CHANGE = 'NOTIFY_GALLERY_CHANGE'
export const NOTIFY_UPLOAD_CHANGE = 'NOTIFY_UPLOAD_CHANGE'
export const NOTIFY_TOGGLE_COMMENTS = 'NOTIFY_TOGGLE_COMMENTS'

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_CONNECT = 'LOGIN_CONNECT';
export const LOGIN_VALIDATE = 'LOGIN_VALIDATE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGIN_ANONYMOUS = 'LOGIN_ANONYMOUS';

// used in server hooks
export const ERROR_STATUS = 'error';
export const SUCCESS_STATUS = 'success';
export const PENDING_STATUS = 'pending';
export const EDIT_STATUS = 'edit';
export const NONE_STATUS = 'none';

export const ACTIVE_PEEK_MODE = 'active';
export const ARCHIVED_PEEK_MODE = 'archived';
export const BLOCKED_PEEK_MODE = 'blocked';
export const ONLINE_PEEK_MODE = 'online';

export const loginStatus = {
    SUCCESS: 'success',
    ERROR: 'error',
    REQUEST: 'request',
    ANONYMOUS: 'anonymous',
    LOGOUT: 'logout',
    CONNECT: 'connect'
};

export const FETCH_CONFIGURATION = 'FETCH_CONFIGURATION';
export const FETCH_PAGE_SIZE = 10;

export const EVENT_FRIEND_REQUESTED = 'EVENT_FRIEND_REQUESTED';
export const EVENT_FRIEND_CANCELLED = 'EVENT_FRIEND_CANCELLED';
export const EVENT_FRIEND_ACCEPTED = 'EVENT_FRIEND_ACCEPTED';
export const EVENT_FRIEND_IGNORED = 'EVENT_FRIEND_IGNORED';
export const EVENT_FRIEND_DELETED = 'EVENT_FRIEND_DELETED';
export const EVENT_FRIEND_BLOCKED = 'EVENT_FRIEND_BLOCKED';
export const EVENT_FRIEND_UNBLOCKED = 'EVENT_FRIEND_UNBLOCKED';
export const EVENT_FOLLOWER_BLOCKED = 'EVENT_FOLLOWER_BLOCKED';
export const EVENT_FOLLOWER_UNBLOCKED = 'EVENT_FOLLOWER_UNBLOCKED';
export const EVENT_FOLLOWER_ADDED = 'EVENT_FOLLOWER_ADDED';
export const EVENT_FOLLOWER_DELETED = 'EVENT_FOLLOWER_DELETED';

export const EVENT_CHAT_DELIVERED = 'EVENT_CHAT_DELIVERED';
export const EVENT_CHAT_DELIVERED_ACK = 'EVENT_CHAT_DELIVERED_ACK';
export const EVENT_CHAT_CONSUMED = 'EVENT_CHAT_CONSUMED';
export const EVENT_CHAT_CONSUMED_ACK = 'EVENT_CHAT_CONSUMED_ACK';
export const EVENT_CHAT_DELETED = 'EVENT_CHAT_DELETED';
export const EVENT_CHAT_DELETED_ACK = 'EVENT_CHAT_DELETED_ACK';
export const EVENT_CHAT_RECEIVED = 'EVENT_CHAT_RECEIVED';
export const FETCH_CHAT_ENTRIES = 'FETCH_CHAT_ENTRIES';
export const RESET_CHAT_ENTRIES = 'RESET_CHAT_ENTRIES';
export const FETCH_CHAT_COUNT = 'FETCH_CHAT_COUNT';
export const EVENT_CHAT_PENDING = 'EVENT_CHAT_PENDING';

export const CHAT_ENTRY_CONSUMED = 'CONSUMED';
export const CHAT_ENTRY_DELIVERED = 'DELIVERED';
export const CHAT_ENTRY_RECEIVED = 'RECEIVED';

export const LOCAL_MEMBER_PROFILE = 'LOCAL_MEMBER_PROFILE';
export const LOCAL_MEMBER_REMOVE = 'LOCAL_MEMBER_REMOVE';
export const LOCAL_OPEN_FRIEND_CHAT = 'LOCAL_OPEN_FRIEND_CHAT';

// used for automatic event bubbling - thrown in a child component and catched by some onClick's parent
export const BUBBLE_CLOSE_BUTTON_ID = 'BUBBLE_CLOSE_BUTTON_ID';

/* REGEX'ES Achtung! remember to reset the lastIndex = 0 before use -- see g flag */
export const YOUTUBE_REGEX = /(?:https?:)?(?:\/\/)?(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/\S*?[^\w\s-])((?!videoseries)[\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gim;


export function asyncFetchPosts(username, space) {
    console.log('asyncFetchPosts', username, space);

    return isPreAuthorized() ? authFetchPosts(username, space) :
        anonymousFetchPosts(username, space);
}

export function authFetchPosts(username, space) {
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/posts/${space}`, authConfig())
            .then(response => {
                dispatch(fetchPosts(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchPosts(username, space))));
            });
    };

    function fetchPosts(posts) {
        return {type: FETCH_POSTS, posts}
    }
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// ** EXPERIMENTAL **
export function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export function asyncFetchPostsPage(username, space, page, pagesize = FETCH_PAGE_SIZE, callback) {
    console.log('asyncFetchPostsPage', username, space, page);

    return isPreAuthorized() ? authFetchPostsPage(username, space, page, pagesize, callback) :
        anonymousFetchPostsPage(username, space, page, pagesize, callback);
}

export function authFetchPostsPage(username, space, page, size = FETCH_PAGE_SIZE, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/posts/${space}/page/${page}/${size}`, authConfig())
            .then(response => {
                dispatch(fetchPostsPage(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchPostsPage(username, space, page, size, callback))));
            });
    };
    function fetchPostsPage(page) {
        callback && callback(page);
        return {type: FETCH_POSTS_PAGE, page}
    }
}

export function asyncFetchLoginData(username) {
    return isPreAuthorized() ? authFetchLoginData(username) : anonymousFetchLoginData(username);
}

export function authFetchLoginData(username) {

    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/userdata`, authConfig())
            .then(response => {
                dispatch(fetchLoginData(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchLoginData(username))))
            })
    };

    function fetchLoginData(userdata) {
        return {type: FETCH_LOGINDATA, userdata}
    }
}

export function asyncFetchUserData(username, callback) {
    return isPreAuthorized() ? authFetchUserData(username, callback) : anonymousFetchUserData(username, callback);
}

export function authFetchUserData(username, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/userdata`, authConfig())
            .then(response => {
                dispatch(fetchUserData(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchUserData(username, callback))))
            })
    };

    function fetchUserData(userdata) {
        callback && callback(userdata);
        return {type: FETCH_USERDATA, userdata}
    }
}

export function asyncUpdateUserAvatar(username, values, callback) {
    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/userdata/avatar`, values, authConfig())
            .then(response => {
                dispatch(updateUserData(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdateUserAvatar(username, values, callback))))
            })
    };

    function updateUserData(logindata) {
        callback && callback(logindata);
        return {type: UPDATE_LOGINDATA, logindata}
    }
}

// actually updating the userdata of a user
export function asyncUpdateUserStatus(username, values, callback) {
    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/status`, values, authConfig())
            .then(response => {
                dispatch(updateUserStatus(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdateUserStatus(username, values, callback))))
            })
    };

    function updateUserStatus(userdata) {
        callback && callback(userdata);
        return {type: UPDATE_USER_STATUS, userdata}
    }
}

export function asyncUpdateUserAddress(username, values, callback) {
    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/userdata/address`, values, authConfig())
            .then(response => {
                dispatch(updateUserAddress(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdateUserAddress(username, values, callback))))
            })
    };

    function updateUserAddress(userdata) {
        callback && callback(userdata);
        return {type: UPDATE_LOGINDATA_ADDRESS, userdata}
    }
}

export function asyncUpdateUserAccount(username, values, callback) {
    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/userdata/account`, values, authConfig())
            .then(response => {
                dispatch(updateUserAccount(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdateUserAccount(username, values, callback))))
            })
    };

    function updateUserAccount(user) {
        callback && callback(user);
        return {type: UPDATE_LOGINDATA_ACCOUNT, user}
    }
}

// TODO
export function asyncUpdateUserPassword(username, values, callback) {
    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/userdata/password`, values, authConfig())
            .then(response => {
                dispatch(updateUserPassword(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdateUserPassword(username, values, callback))))
            })
    };

    function updateUserPassword(user) {
        callback && callback(user);
        return {type: UPDATE_USER_PASSWORD, user}
    }
}


export function asyncUpdateSurrogateAvatar(username, values, callback) {
    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/userdata/avatar`, values, authConfig())
            .then(response => {
                dispatch(updateSurrogateAvatar(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdateSurrogateAvatar(username, values, callback))))
            })
    };

    function updateSurrogateAvatar(surrogatedata) {
        callback && callback(surrogatedata);
        return {type: UPDATE_SURROGATEDATA, surrogatedata}
    }
}

export function asyncUpdateUserData(username, values, callback) {
    return dispatch => {
        axios.post(`${env.ROOT_USER_URL}/${username}/userdata/update`, values, authConfig())
            .then(response => {
                dispatch(updateUserData(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdateUserData(username, values, callback))))
            })
    };

    function updateUserData(userdata) {
        callback && callback(userdata);
        return {type: UPDATE_USERDATA, userdata}
    }
}

export function asyncUpdateUserSecurity(username, values, callback) {
    return dispatch => {
        axios.post(`${env.ROOT_USER_URL}/${username}/userdata/security`, values, authConfig())
            .then(response => {
                dispatch(updateUseDataSecurity(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdateUserSecurity(username, values, callback))))
            })
    };

    function updateUseDataSecurity(userdata) {
        callback && callback(userdata);
        return {type: UPDATE_USERDATA_SECURITY, userdata}
    }
}

export function asyncFetchComments(username, postId, callback) {
    console.log('asyncFetchComments', username, postId);
    return isPreAuthorized() ? authFetchComments(username, postId, callback) : anonymousFetchComments(username, postId);
}

export function authFetchComments(username, postId, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/comments/${postId}`, authConfig())
            .then(response => {
                dispatch(fetchComments(response.data, postId, callback));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchComments(username, postId, callback))));
            });

    };

    function fetchComments(comments, postId, callback) {
        callback && callback(comments, postId);
        return {type: FETCH_COMMENTS, comments, id: postId}
    }
}

export function asyncCreatePostLike(username, postId, values, callback) {

    return dispatch => {
        axios.post(`${env.ROOT_USER_URL}/${username}/likes/${postId}`, values, authConfig())
            .then(response => {
                dispatch(createPostLike(response.data, postId));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncCreatePostLike(username, postId, values, callback))));
            })
    };

    function createPostLike(like, postId) {
        callback && callback(like);
        return {type: CREATE_LIKE, like, meta: {id: postId}}
    }
}

export function asyncRemovePostLike(username, postId, likeId, callback) {

    return dispatch => {
        axios.delete(`${env.ROOT_USER_URL}/${username}/likes/${postId}/remove/${likeId}`, authConfig())
            .then(response => {
                dispatch(removePostLike(response.data, postId));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncRemovePostLike(username, postId, likeId, callback))));
            })
    };

    function removePostLike(like, postId) {
        callback && callback(like);
        return {type: REMOVE_LIKE, like, meta: {id: postId}}
    }
}

export function asyncCreateCommentLike(username, postId, commentId, values, callback) {
    return dispatch => {
        axios.post(`${env.ROOT_USER_URL}/${username}/commentlikes/${commentId}`, values, authConfig())
            .then(response => {
                dispatch(createCommentLike(response.data, postId, commentId));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncCreateCommentLike(username, postId, commentId, values, callback))));
            })
    };

    function createCommentLike(like, postId, commentId) {
        callback && callback(like);
        // return {type: CREATE_COMMENT_LIKE, like, meta: {id: commentId}}
        return {type: CREATE_COMMENT_LIKE, like, postId: postId, commentId: commentId}
    }
}

export function asyncRemoveCommentLike(username, postId, commentId, likeId, callback) {

    return dispatch => {
        axios.delete(`${env.ROOT_USER_URL}/${username}/commentlikes/${commentId}/remove/${likeId}`, authConfig())
            .then(response => {
                dispatch(removeCommentLike(response.data, postId, commentId));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncRemoveCommentLike(username, postId, commentId, likeId, callback))));
            })
    };

    function removeCommentLike(like, postId, commentId) {
        callback && callback(like);
        // return {type: REMOVE_COMMENT_LIKE, like, meta: {id: commentId}};
        return {type: REMOVE_COMMENT_LIKE, like, postId: postId, commentId: commentId};
    }
}

export function asyncCreateComment(username, postId, values, callback) {

    return dispatch => {
        axios.post(`${env.ROOT_USER_URL}/${username}/comments/${postId}`, values, authConfig())
            .then(response => {
                dispatch(createComment(response.data, postId));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncCreateComment(username, postId, values, callback))));
            })
    };

    // function createComment(comment, postId) {callback && callback(comment); return {type: CREATE_COMMENT, comment, meta: {id: postId}}}
    function createComment(comment, postId) {
        callback && callback(comment);
        return {type: CREATE_COMMENT, comment, id: postId}
    }
}

export function asyncCreatePost(username, values, space = 'home', callback) {

    return dispatch => {
        axios.post(`${env.ROOT_USER_URL}/${username}/posts/${space}`, values, authConfig())
            .then(response => {
                dispatch(createPost(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncCreatePost(username, values, space, callback))));
            })
    };

    function createPost(post) {
        callback && callback(post);
        return {type: CREATE_POST, post}
    }
}

export function asyncUpdatePost(username, values, postId, callback) {

    return dispatch => {
        axios.post(`${env.ROOT_USER_URL}/${username}/posts/${postId}/update`, values, authConfig())
            .then(response => {
                dispatch(updatePost(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdatePost(username, values, postId, callback))));
            })
    };

    function updatePost(post) {
        callback && callback(post);
        return {type: UPDATE_POST, post}
    }
}

export function asyncUpdatePostRanking(username, postId, ranking, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/posts/${postId}/ranking/${ranking}`, {}, authConfig())
            .then(response => {
                dispatch(updateRanking(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUpdatePostRanking(username, postId, ranking, callback))));
            })
    };

    function updateRanking(post) {
        callback && callback(post);
        return {type: UPDATE_POST_RANKING, post}
    }
}


export function asyncDeleteMedia(username, postId, mediaId, callback) {

    return dispatch => {
        axios.delete(`${env.ROOT_USER_URL}/${username}/posts/${postId}/media/${mediaId}/delete`, authConfig())
            .then(response => {
                dispatch(deleteMedia(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncDeleteMedia(username, postId, mediaId, callback))));
            })
    };

    function deleteMedia(post) {
        callback && callback(post);
        return {type: DELETE_POST_MEDIA, post}
    }
}

export function asyncReorderPostMedia(username, postId, values, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/posts/${postId}/media/position`, values, authConfig())
            .then(response => {
                dispatch(reorderMediaPosition(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncReorderPostMedia(username, postId, values, callback))));
            })
    };

    function reorderMediaPosition(post) {
        callback && callback(post);
        return {type: REORDER_POST_MEDIA, post}
    }
}

export function asyncDeletePost(username, postId, callback) {

    return dispatch => {
        axios.delete(`${env.ROOT_USER_URL}/${username}/posts/${postId}/delete`, authConfig())
            .then(response => {
                dispatch(deletePost(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncDeletePost(username, postId, callback))));
            })
    };

    function deletePost(post) {
        callback && callback(post);
        return {type: DELETE_POST, post}
    }
}

export function asyncSharePost(username, spaceId, postId, values, callback) {

    return dispatch => {
        axios.post(`${env.ROOT_USER_URL}/${username}/space/${spaceId}/share/${postId}`, values, authConfig())
            .then(response => {
                dispatch(sharePost(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncSharePost(username, spaceId, postId, callback))));
            })
    };

    function sharePost(post) {
        callback && callback(post);
        return {type: SHARE_POST, post}
    }
}

/* always in public mode */
export function asyncFetchConfiguration(callback) {
    console.log('asyncFetchConfiguration')

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/app/configuration`)
            .then(response => {
                dispatch(fetchConfiguration(response.data));
            })
            .catch(error => {
               if(checkIsServerAlive(error)) {
                   dispatch(fetchConfiguration(getLocalSiteConfiguration()));
               }
            })
    };

    function fetchConfiguration(configuration) {
        callback && callback(configuration);
        return {type: FETCH_CONFIGURATION, configuration}
    }
}

// @Deprecated
export function asyncCreateUser(username, values) {
    return dispatch => {
        dispatch(createUserRequest());
        axios.post(`${env.ROOT_PUBLIC_URL}/user/create/${username}`, values)
            .then(response => {
                dispatch(createUserSuccess(response.data));
            })
            .catch(error => {
                console.log(CREATE_USER_FAILURE, error.response);
                dispatch(createUserFailure(error.response));
            })
    };

    function createUserRequest() {
        return {type: CREATE_USER_REQUEST}
    }

    function createUserSuccess(user) {
        return {type: CREATE_USER_SUCCESS, user}
    }

    function createUserFailure(error) {
        return {type: CREATE_USER_FAILURE, error}
    }
}

export function asyncValidateAuth(username, callback) {
    console.log('asyncValidateAuth public');

    (!isPreAuthorized() || !username) && console.log('NOT_AUTHORIZED', username);

    return dispatch => {
        isServerAlive() && axios.get(`${env.ROOT_USER_URL}/${username}/validate/authorization`, authConfig())
            .then(response => {
                dispatch(validateAuth(response.status));
            })
            .catch(error => {
                if(checkIsServerAlive(error)) {
                    dispatch(asyncHandleError(error));
                }
            })
    };

    function validateAuth(httpStatus) {
        callback && callback();
        return {type: LOGIN_VALIDATE, payload: httpStatus}
    }
}

/* only in auth mode */
export function asyncConnectAuth(username, callback) {
    console.log('asyncConnectAuth auth');

    return dispatch => {
        isServerAlive() && axios.get(`${env.ROOT_USER_URL}/${username}/validate/authorization`, authConfig())
            .then(response => {
                console.log(LOGIN_CONNECT, response);
                dispatch(connectAuth(username));
            })
            .catch(error => {
                if(checkIsServerAlive(error)) {
                    dispatch(asyncHandleError(error, () => dispatch(connectAuth(username))))
                }
            })
    };

    function connectAuth(username) {
        callback && callback();
        return {type: LOGIN_CONNECT, username}
    }
}

export function createPost(username, values, space = 'home') {
    const request = axios.post(`${env.ROOT_USER_URL}/${username}/posts/${space}`, values, authConfig());

    return {
        type: CREATE_POST,
        payload: request
    }
}

export function createComment(username, postId, values, callback) {
    const request = axios.post(`${env.ROOT_USER_URL}/${username}/comments/${postId}`, values, authConfig());

    return {
        type: CREATE_COMMENT,
        payload: request,
        meta: {id: postId}
    }
}

export function createLike(username, postId, values) {
    const request = axios.post(`${env.ROOT_USER_URL}/${username}/likes/${postId}`, values, authConfig());

    return {
        type: CREATE_LIKE,
        payload: request,
        meta: {id: postId}
    }
}

export function asyncFetchFriends(username, callback) {
    return isPreAuthorized() ? authFetchFriends(username, callback) : anonymousFetchFriends(username, callback);
}

export function authFetchFriends(username, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/friends`, authConfig())
            .then(response => {
                dispatch(fetchFriends(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchFriends(username, callback))));
            });
    };

    function fetchFriends(friends) {
        callback && callback(friends);
        return {type: FETCH_FRIENDS, friends}
    }
}

export function asyncFetchFriendsPending(username, callback) {
    return isPreAuthorized() ? authFetchFriendsPending(username, callback) : anonymousFetchFriendsPending(username, callback);
}

export function authFetchFriendsPending(username, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/friends/pending`, authConfig())
            .then(response => {
                dispatch(fetchFriendsPending(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchFriendsPending(username, callback))));
            });
    };

    function fetchFriendsPending(friends) {
        callback && callback(friends);
        return {type: FETCH_FRIENDS_PENDING, friends}
    }
}

export function asyncFetchFollowers(username) {
    return isPreAuthorized() ? authFetchFollowers(username) : anonymousFetchFollowers(username);
}

export function authFetchFollowers(username) {
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/followers`, authConfig())
            .then(response => {
                dispatch(fetchFollowers(response));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchFollowers(username))));
            })
    };

    function fetchFollowers(response) {
        return {type: FETCH_FOLLOWERS, payload: response}
    }
}

export function asyncFetchFollowees(username) {
    return isPreAuthorized() ? authFetchFollowees(username) : anonymousFetchFollowees(username);
}

export function authFetchFollowees(username) {
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/followees`, authConfig())
            .then(response => {
                dispatch(fetchFollowees(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchFollowees(username))));
            })
    };

    function fetchFollowees(followees) {
        return {type: FETCH_FOLLOWEES, followees}
    }
}

export function asyncAddFollowee(username, followee, callback) {
    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/followee/add`, {followee: followee}, authConfig())
            .then(response => {
                dispatch(addFollowee(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncAddFollowee(username, followee, callback))));
            });
    };

    function addFollowee(followee) {
        callback && callback(followee);
        return {type: ADD_FOLLOWEE, followee}
    }
}

export function asyncDeleteFollowee(username, followee, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/followee/delete`, {followee: followee}, authConfig())
            .then(response => {
                dispatch(deleteFollowee(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncDeleteFollowee(username, followee, callback))));
            });
    };

    function deleteFollowee(followee) {
        callback && callback(followee);
        return {type: DELETE_FOLLOWEE, followee}
    }
}

export function asyncBlockFollower(username, follower, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/follower/block`, {follower: follower}, authConfig())
            .then(response => {
                dispatch(blockFollower(response))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncBlockFollower(username, follower, callback))));
            });
    };

    function blockFollower(response) {
        if (callback !== undefined) {
            callback(username)
        }
        return {type: BLOCK_FOLLOWER, payload: response}
    }
}

export function asyncUnblockFollower(username, follower, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/follower/unblock`, {follower: follower}, authConfig())
            .then(response => {
                dispatch(unblockFollower(response))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUnblockFollower(username, follower, callback))));
            });
    };

    function unblockFollower(response) {
        if (callback !== undefined) {
            callback(username)
        }
        return {type: UNBLOCK_FOLLOWER, payload: response}
    }
}

export function asyncAddFriend(username, friend, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/friend/add`, {friend: friend}, authConfig())
            .then(response => {
                dispatch(addFriend(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncAddFriend(username, friend, callback))));
            });
    };

    function addFriend(friend) {
        if (callback !== undefined) {
            callback(friend)
        }
        return {type: ADD_FRIEND, friend}
    }
}

export function asyncDeleteFriend(username, friend, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/friend/delete`, {friend: friend}, authConfig())
            .then(response => {
                dispatch(deleteFriend(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncDeleteFriend(username, friend, callback))));
            });
    };

    function deleteFriend(friend) {
        callback && callback(friend);
        return {type: DELETE_FRIEND, friend}
    }
}

export function asyncBlockFriend(username, friend, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/friend/block`, {friend: friend}, authConfig())
            .then(response => {
                dispatch(blockFriend(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncBlockFriend(username, friend, callback))));
            });
    };

    function blockFriend(friend) {
        callback && callback(friend);
        return {type: BLOCK_FRIEND, friend}
    }
}

export function asyncUnblockFriend(username, friend, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/friend/unblock`, {friend: friend}, authConfig())
            .then(response => {
                dispatch(unblockFriend(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncUnblockFriend(username, friend, callback))));
            });
    };

    function unblockFriend(friend) {
        callback && callback(friend);
        return {type: UNBLOCK_FRIEND, friend}
    }
}

export function asyncIgnoreFriend(username, friend, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/friend/ignore`, {friend: friend}, authConfig())
            .then(response => {
                dispatch(ignoreFriend(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncIgnoreFriend(username, friend, callback))));
            });
    };

    function ignoreFriend(friend) {
        callback && callback(friend);
        return {type: IGNORE_FRIEND, friend}
    }
}

export function asyncCancelFriend(username, friend, callback) {
    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/friend/cancel`, {friend: friend}, authConfig())
            .then(response => {
                dispatch(cancelFriend(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncCancelFriend(username, friend, callback))));
            });
    };

    function cancelFriend(friend) {
        if (callback !== undefined) {
            callback(friend)
        }
        return {type: CANCEL_FRIEND, friend}
    }
}

export function asyncAcceptFriend(username, friend, callback) {

    return dispatch => {
        axios.put(`${env.ROOT_USER_URL}/${username}/friend/accept`, {friend: friend}, authConfig())
            .then(response => {
                dispatch(acceptFriend(response.data))
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncAcceptFriend(username, friend, callback))));
            });
    };

    function acceptFriend(friend) {
        callback && callback(friend);
        return {type: ACCEPT_FRIEND, friend}
    }
}

export function asyncFetchChatEntries(username, chatId, callback) {
    return isPreAuthorized() ? authFetchChatEntries(username, chatId, callback) :
        anonymousFetchChatEntries(username, chatId, callback);
}

export function authFetchChatEntries(username, chatId, callback) {
    console.log('authFetchChatEntries', username, chatId);
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/chat/${chatId}/entries`, authConfig())
            .then(response => {
                dispatch(fetchChatEntries(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchChatEntries(username, chatId, callback))));
            })
    };

    function fetchChatEntries(data) {
        callback && callback(data);
        return {type: FETCH_CHAT_ENTRIES, payload: data}
    }
}



export function asyncFetchChatCount(username, chatId, callback) {
    return isPreAuthorized() ? authFetchChatCount(username, chatId, callback)
        : anonymousFetchChatCount(username, chatId, callback);
}

export function authFetchChatCount(username, chatId, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_USER_URL}/${username}/chat/${chatId}/count`, authConfig())
            .then(response => {
                dispatch(fetchChatCount(response.data));
            })
            .catch(error => {
                dispatch(asyncHandleError(error, () => dispatch(asyncFetchChatCount(username, chatId, callback))));
            })
    };

    function fetchChatCount(data) {
        if (callback !== undefined) {
            callback()
        }
        return {type: FETCH_CHAT_COUNT, payload: data}
    }
}

/* locally generated events and data - no server intervention */
export function friendEventHandler(event, user) {
    return {type: event, user}
}

export function followerEventHandler(event, follower) {
    return {type: event, follower}
}

export function chatEventHandler(event, data) {
    return {type: event, data}
}

export function authRequest(principal) {
    return {type: LOGIN_REQUEST, principal}
}

export function authSuccess(principal) {
    return {type: LOGIN_SUCCESS, principal}
}

export function authFailure(error) {
    return {type: LOGIN_FAILURE, error}
}

export function authAnonymous(principal) {
    return {type: LOGIN_ANONYMOUS, principal}
}

export function localUpdateUserAvatar(logindata) {
    return {type: LOCAL_UPDATE_LOGINDATA, logindata}
}

export function localMemberProfile(member) {
    return {type: LOCAL_MEMBER_PROFILE, member}
}

export function localRemoveMember(member) {
    return {type: LOCAL_MEMBER_REMOVE, member}
}

export function localOpenFriendChat(friend) {
    return {type: LOCAL_OPEN_FRIEND_CHAT, friend}
}

export function localResetCreateUser() {
    return {type: CREATE_USER_RESET}
}

export function localResetLoginData() {
    return {type: RESET_LOGINDATA}
}

// data as in {action: 'fetch', status: 'success', payload: page}
export function notifyPageChange(action, status, payload) {
    const data = {action: action, status: status, payload: payload};
    return {type: NOTIFY_PAGE_CHANGE, data}
}

// possible actions UPDATE, status PENDING, SUCCESS, NONE
export function notifyUploadChange(action, status, payload) {
    const data = {action: action, status: status, payload: payload};
    return {type: NOTIFY_UPLOAD_CHANGE, data}
}

// as in action 'toggle', toggle true or false and originating pageId
export function notifyToggleComments(action, toggle, postId) {
    const data = {action: action + new Date().getTime(), toggle: toggle, postId: postId};
    return {type: NOTIFY_TOGGLE_COMMENTS, data}
}

// action one of CREATE, DELETE, UPDATE
// using this one as a marker for forcing a refresh since the data itself is stored locally
// a gallery is a plain generic space
export function notifyGalleryChange(action, spaceId, space) {

    console.log('notifyGalleryChange' , action)
    const data = {action: action + new Date().getTime(), spaceId: spaceId, space: space};
    return {type: NOTIFY_GALLERY_CHANGE, data}
}

export function notifySpaceChange(action, status, payload) {
    const data = {action: action, status: status, payload: payload};
    return {type: NOTIFY_SPACE_CHANGE, data}
}

export function localResetChatEntries() {
    return {type: RESET_CHAT_ENTRIES};
}
export function localResetFriends() {
    const friends = [];
    return {type: FETCH_FRIENDS, friends};
}
export function localResetPending() {
    const friends = [];
    return {type: FETCH_FRIENDS_PENDING, friends};
}

/**
 * window location potentially dangerous since may trigger a browser re-render loop
 */
export function logoutRequest() {
    removeBearer();
    window.location.href = "/";
    return {type: LOGOUT_REQUEST}
}
